import { logDsdDsdCompareDownload } from "@/apis/dsd-dsd-compare/route";
import { useMutation } from "@tanstack/react-query";

export const useLogDsdDsdCompareDownload = () => {
  return useMutation({
    mutationFn: () => logDsdDsdCompareDownload(),
  });
};
